/**
 * Single Post Image Modal
 */
import { initPostMediaModal } from './post-media-modal.js';

initPostMediaModal();
